import { FieldPath } from '@/domain/mitarbeiter/features/anlageassistent/types/types';

/**
 * FORM_RESETS ist das Konfigurationsobjekt für alle Feldresets.
 * Als key wird ein Fieldpath der Form erwartet.
 * Value ist ein Array von abhängigen Feldern, die zurückgesetzt werden sollen, wenn sich der Wert des Key-Feldes ändert.
 */
export const FORM_RESETS: Partial<Record<FieldPath, FieldPath[]>> = {
  'anstellungsverhaeltnis.anstellung.befristet': [
    'anstellungsverhaeltnis.anstellung.befristung',
  ],
  'bezahlung.bezahlungsart.art': [
    'bezahlung.bezahlungsart.stundenlohn',
    'bezahlung.bezahlungsart.monatsgehalt',
    'bezahlung.bezahlungsart.tarifGruppe',
    'bezahlung.arbeitszeitkonto.gehaltsempfaenger.sollstunden',
    'bezahlung.arbeitszeitkonto.gehaltsempfaenger.stundenpensum',
    'bezahlung.arbeitszeitkonto.gehaltsempfaenger.berechnungsartMonat',
    'bezahlung.arbeitszeitkonto.gehaltsempfaenger.monatsstunden',
    'bezahlung.arbeitszeitkonto.gehaltsempfaenger.unbezahlteUeberstundenMonat',
    'bezahlung.arbeitszeitkonto.tagessoll',
    'bezahlung.arbeitszeitkonto.arbeitstage',
    'bezahlung.arbeitszeitkonto.gehaltsempfaenger.wochenstunden',
    'bezahlung.arbeitszeitkonto.gehaltsempfaenger.unbezahlteUeberstundenWoche',
    'bezahlung.arbeitszeitkonto.stundenloehner.auszahlungsgrenze',
    'bezahlung.arbeitszeitkonto.stundenloehner.richtwert',
    'bezahlung.arbeitszeitkonto.stundenloehner.auszahlungsgrenzeEinheit',
    'bezahlung.arbeitszeitkonto.stundenloehner.auszahlungsgrenzeEuro',
    'bezahlung.arbeitszeitkonto.stundenloehner.auszahlungsgrenzeStunden',
  ],
  'bezahlung.bezahlungsart.tarifGruppe': [
    'bezahlung.bezahlungsart.stundenlohn',
    'bezahlung.bezahlungsart.monatsgehalt',
  ],
  'bezahlung.arbeitszeitkonto.gehaltsempfaenger.sollstunden': [
    'bezahlung.arbeitszeitkonto.gehaltsempfaenger.stundenpensum',
    'bezahlung.arbeitszeitkonto.gehaltsempfaenger.berechnungsartMonat',
    'bezahlung.arbeitszeitkonto.gehaltsempfaenger.monatsstunden',
    'bezahlung.arbeitszeitkonto.gehaltsempfaenger.unbezahlteUeberstundenMonat',
    'bezahlung.arbeitszeitkonto.tagessoll',
    'bezahlung.arbeitszeitkonto.arbeitstage',
    'bezahlung.arbeitszeitkonto.gehaltsempfaenger.wochenstunden',
    'bezahlung.arbeitszeitkonto.gehaltsempfaenger.unbezahlteUeberstundenWoche',
  ],
  'bezahlung.arbeitszeitkonto.gehaltsempfaenger.stundenpensum': [
    'bezahlung.arbeitszeitkonto.gehaltsempfaenger.berechnungsartMonat',
    'bezahlung.arbeitszeitkonto.gehaltsempfaenger.monatsstunden',
    'bezahlung.arbeitszeitkonto.gehaltsempfaenger.unbezahlteUeberstundenMonat',
    'bezahlung.arbeitszeitkonto.tagessoll',
    'bezahlung.arbeitszeitkonto.arbeitstage',
    'bezahlung.arbeitszeitkonto.gehaltsempfaenger.wochenstunden',
    'bezahlung.arbeitszeitkonto.gehaltsempfaenger.unbezahlteUeberstundenWoche',
  ],
  'bezahlung.arbeitszeitkonto.gehaltsempfaenger.berechnungsartMonat': [
    'bezahlung.arbeitszeitkonto.gehaltsempfaenger.monatsstunden',
    'bezahlung.arbeitszeitkonto.gehaltsempfaenger.unbezahlteUeberstundenMonat',
    'bezahlung.arbeitszeitkonto.tagessoll',
    'bezahlung.arbeitszeitkonto.arbeitstage',
  ],
  'bezahlung.arbeitszeitkonto.stundenloehner.auszahlungsgrenze': [
    'bezahlung.arbeitszeitkonto.stundenloehner.richtwert',
    'bezahlung.arbeitszeitkonto.stundenloehner.auszahlungsgrenzeEinheit',
    'bezahlung.arbeitszeitkonto.stundenloehner.auszahlungsgrenzeEuro',
    'bezahlung.arbeitszeitkonto.stundenloehner.auszahlungsgrenzeStunden',
    'bezahlung.arbeitszeitkonto.stundenloehner.richtwertEinheit',
    'bezahlung.arbeitszeitkonto.stundenloehner.richtwertEuro',
    'bezahlung.arbeitszeitkonto.stundenloehner.richtwertStunden',
    'bezahlung.arbeitszeitkonto.tagessoll',
    'bezahlung.arbeitszeitkonto.arbeitstage',
  ],
  'bezahlung.arbeitszeitkonto.stundenloehner.auszahlungsgrenzeEinheit': [
    'bezahlung.arbeitszeitkonto.stundenloehner.auszahlungsgrenzeEuro',
    'bezahlung.arbeitszeitkonto.stundenloehner.auszahlungsgrenzeStunden',
  ],
  'bezahlung.arbeitszeitkonto.stundenloehner.richtwert': [
    'bezahlung.arbeitszeitkonto.stundenloehner.richtwertEinheit',
    'bezahlung.arbeitszeitkonto.stundenloehner.richtwertEuro',
    'bezahlung.arbeitszeitkonto.stundenloehner.richtwertStunden',
    'bezahlung.arbeitszeitkonto.tagessoll',
    'bezahlung.arbeitszeitkonto.arbeitstage',
  ],
  'bezahlung.arbeitszeitkonto.stundenloehner.richtwertEinheit': [
    'bezahlung.arbeitszeitkonto.stundenloehner.richtwertEuro',
    'bezahlung.arbeitszeitkonto.stundenloehner.richtwertStunden',
    'bezahlung.arbeitszeitkonto.tagessoll',
    'bezahlung.arbeitszeitkonto.arbeitstage',
  ],
  'bezahlung.zuschlaege.zuschlaege': [
    'bezahlung.zuschlaege.zuschlagsgruppe',
    'bezahlung.zuschlaege.pauschaleZuschlaege',
    'bezahlung.zuschlaege.uebertariflicheZahlung',
  ],
  'abwesenheiten.allgemein.stundenBewertung': [
    'abwesenheiten.allgemein.stunden',
    'abwesenheiten.allgemein.dynamisch',
    'abwesenheiten.allgemein.dynamisch_drei_monatsschnitt_berechnungsgrundlage',
    'abwesenheiten.allgemein.dynamisch_wochenschnitt_limitieren',
    'abwesenheiten.allgemein.dynamisch_wochenschnitt_start',
  ],
  'abwesenheiten.allgemein.dynamisch': [
    'abwesenheiten.allgemein.dynamisch_drei_monatsschnitt_berechnungsgrundlage',
    'abwesenheiten.allgemein.dynamisch_wochenschnitt_limitieren',
    'abwesenheiten.allgemein.dynamisch_wochenschnitt_start',
  ],
  'speicheroptionen.personalzugang': [
    'speicheroptionen.personalfragebogen',
    'speicheroptionen.personalfragebogenNachricht',
  ],
  'speicheroptionen.personalfragebogen': [
    'speicheroptionen.personalfragebogenNachricht',
  ],
} as const;
